var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 80,
    viewBox: "0 0 104 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4550_643581)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 79,
    transform: "translate(0 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8867 23.138C17.8867 23.138 24.5904 19.8053 32.1573 22.3348C39.7243 24.8644 25.0238 29.0004 25.0238 29.0004L17.8867 23.138Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M17.8867 23.138C17.8867 23.138 24.5904 19.8053 32.1573 22.3348C39.7243 24.8644 25.0238 29.0004 25.0238 29.0004L17.8867 23.138Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72563 25.541C9.72563 25.541 5.12698 28.1005 3.98161 34.4328C2.83625 40.7651 18.5412 49.3203 18.5412 49.3203L28.2991 42.2248C28.2991 42.2248 34.0947 17.489 13.7121 24.1279L9.72563 25.541Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M53.6275 79.8144C80.296 79.8144 101.915 76.8032 101.915 73.0888C101.915 69.3744 80.296 66.3633 53.6275 66.3633C26.959 66.3633 5.33984 69.3744 5.33984 73.0888C5.33984 76.8032 26.959 79.8144 53.6275 79.8144Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4451 11.3594H25.0273V73.089H80.4451V11.3594Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9807 46.3477H66.2383V53.2765H73.9807V46.3477Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9807 56.5957H66.2383V63.5245H73.9807V56.5957Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M68.3838 51.2363C68.3838 51.2363 54.2817 53.5059 60.8891 73.0893H75.9818L68.3838 51.2363Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5449 49.3202L25.1798 57.8721L25.0284 44.5977L18.5449 49.3202Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4267 6.87402H24.1172V22.3348H81.4267V6.87402Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2432 73.0924C84.4332 73.0924 90.2619 67.4446 90.2619 60.4778C90.2619 53.511 84.4332 47.8633 77.2432 47.8633C70.0532 47.8633 64.2246 53.511 64.2246 60.4778C64.2246 67.4446 70.0532 73.0924 77.2432 73.0924Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3438 60.3216L76.1435 64.9908L81.9839 56.5322",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7827 1.13184H35.1875V14.6062H39.7827V1.13184Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M42.8169 6.77051H39.7832V14.6025H42.8169V6.77051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M73.1391 6.77051H70.1055V14.6025H73.1391V6.77051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1069 1.13184H65.5117V14.6062H70.1069V1.13184Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1565 28.4941H32.5781V32.1802H45.1565V28.4941Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6955 36.1621H32.9531V43.0909H40.6955V36.1621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M51.9318 36.1621H44.1895V43.0909H51.9318V36.1621Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.051 36.1621H55.3086V43.0909H63.051V36.1621Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9807 36.1621H66.2383V43.0909H73.9807V36.1621Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50808 25.6705C9.50808 25.6705 9.31203 28.1001 11.6062 29.2666C13.9004 30.4331 13.6699 27.4702 13.6699 27.4702C13.6699 27.4702 14.5057 28.3434 15.8334 27.1936C17.161 26.0438 14.0414 23.9375 14.0414 23.9375L9.50808 25.6705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6955 46.3477H32.9531V53.2765H40.6955V46.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M51.9318 46.3477H44.1895V53.2765H51.9318V46.3477Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M63.051 46.3477H55.3086V53.2765H63.051V46.3477Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6955 56.5957H32.9531V63.5245H40.6955V56.5957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M51.9318 56.5957H44.1895V63.5245H51.9318V56.5957Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M63.051 56.5957H55.3086V63.5245H63.051V56.5957Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0835 22.9878C13.2557 23.4952 13.4578 23.9926 13.6889 24.4776C14.0122 25.1441 14.3114 26.2173 13.3449 26.9338C11.8659 28.0403 10.1014 25.7507 10.1014 25.7507C10.1014 25.7507 7.82789 23.9143 9.41352 22.7079C10.8719 21.6247 12.2683 20.6682 13.0835 22.9878Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61977 22.4347C7.30811 22.7668 7.13416 23.1989 7.13136 23.6478C7.11574 23.8763 7.16967 24.1042 7.28645 24.3032C7.40322 24.5023 7.57772 24.6637 7.78831 24.7676C8.86145 25.2575 10.1031 25.7674 10.1031 25.7674C10.1031 25.7674 8.88208 24.7043 10.1031 24.2477C11.3242 23.7911 12.6897 24.1844 13.0818 23.0046C13.4739 21.8248 13.7697 21.1549 13.0818 20.4183C12.3939 19.6818 12.0189 18.582 10.8839 19.5618C9.74885 20.5417 9.85203 19.3552 8.85801 18.9986C7.86398 18.642 6.66359 19.1952 7.13824 20.0517C7.53723 20.7849 8.21825 21.7381 7.61977 22.4347Z",
    fill: "#24285B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.604 33.1589C10.8507 29.9595 6.39995 29.3096 4.58388 32.0791C2.31034 35.5552 -0.592626 41.2576 0.439234 46.6533C2.04206 55.2052 8.93832 62.7606 25.0388 57.8715V55.3185C25.0388 55.3185 19.3636 56.495 14.445 54.682C9.52649 52.869 7.29079 47.1899 9.60216 42.554C10.9298 39.8711 12.3056 36.1451 11.604 33.1589Z",
    fill: "rgba(38, 127, 215, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.604 33.1589C10.8507 29.9595 6.39995 29.3096 4.58388 32.0791C2.31034 35.5552 -0.592626 41.2576 0.439234 46.6533C2.04206 55.2052 8.93832 62.7606 25.0388 57.8715V55.3185C25.0388 55.3185 19.3636 56.495 14.445 54.682C9.52649 52.869 7.29079 47.1899 9.60216 42.554C10.9298 39.8711 12.3056 36.1451 11.604 33.1589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0284 57.8715C25.0284 57.8715 22.6207 56.4284 24.1169 54.2621C25.6131 52.0958 28.6434 54.9853 25.0284 57.8715Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M80.4451 22.334H25.0273V25.5401H80.4451V22.334Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.259 25.8002C10.259 25.8002 9.76372 25.087 9.09645 25.4669C8.42918 25.8469 9.45073 27.12 10.259 25.8002Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4465 24.6207C13.4465 24.6207 12.8205 24.0075 13.3262 23.4342C13.8318 22.861 14.9427 24.1008 13.4465 24.6207Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9453 6.87435C45.9453 6.87435 47.7786 4.20813 49.8423 5.54124C51.906 6.87435 50.0728 8.64072 45.9453 6.87435Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M17.8884 23.1382C17.8884 23.1382 27.2439 37.3758 14.2734 46.7075L18.5419 49.3204L25.0289 44.5979V24.4346C25.0289 24.4346 22.6453 22.4349 17.8884 23.1382Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4550_643581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 79,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-img.806fd3469c9e224ac1ddda748de3cd2f.svg";